import { ReactNode } from 'react';
import { useAuthorization } from '../../utils/hooks';
import styles from './LoginLayout.module.css';
import EnvironmentBanner from '../../components/ui/EnvironmentBanner/EnvironmentBanner';

interface ILoginLayout {
  children: ReactNode;
}

export const LoginLayout = ({ children }: ILoginLayout) => {
  useAuthorization();
  return (
    <>
      <a className="sr-only" href="#mainContent">
        Skip to main content
      </a>
      <EnvironmentBanner />
      <div className="d-flex" id="wrapper">
        <div id="mainContent" className={styles.loginWrapper}>
          <div className="container-fluid">{children}</div>
        </div>
      </div>
    </>
  );
};
